import { useState } from "react";
import { Button } from "react-bootstrap";
import { BsChatRightDotsFill, BsCurrencyBitcoin } from "react-icons/bs";
import { IoMdArrowForward } from "react-icons/io";
import { IoClose, IoSettings } from "react-icons/io5";
import { MdOutlineGames } from "react-icons/md";
import { RiExchangeDollarLine } from "react-icons/ri";
import { TbHomeSignal } from "react-icons/tb";
import { NavLink, useLocation } from "react-router-dom";
import LogoutModal from "../modal/LogoutModal";


import { FaUsersCog } from "react-icons/fa";
import logo from "../../assets/img/logo.png";

const DashboardSidebar = ({ closeSidebar, activePage, isCollapsed }) => {
  const [open, setOpen] = useState(false);
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const location = useLocation();

  const nestedActive = (path) => {
    if (location.pathname.includes(path)) {
      return "active-light";
    } else {
      return "";
    }
  };
  const menuItems = [
    // { to: "/admin/dashboard", label: "Dashboard", icon: <RxDashboard />, page: "dashboard" },
    // { to: "/admin/orders", label: "Orders", icon: <PiShoppingCartBold />, page: "orders" },
    // { to: "/admin/customers", label: "Customers", icon: <PiUsersThree />, page: "customers" },
    // { to: "/admin/distributors", label: "Distributors", icon: <TbHomeSignal />, page: "distributors" },
    // { to: "/admin/shopowners", label: "Shop Owners", icon: <AiOutlineShop />, page: "shopowners" },
    // { to: "/admin/riders", label: "Riders", icon: <FiTruck />, page: "riders" },
    { to: "/admin/user-management", label: "User Management", icon: <FaUsersCog />, page: "user" },
    { to: "/admin/game", label: "Games", icon: <MdOutlineGames />, page: "user" },
    { to: "/admin/cc-query-management", label: "User Query", icon: <BsCurrencyBitcoin />, page: "ccQuery" },
    { to: "/admin/transaction", label: "Transaction", icon: <RiExchangeDollarLine />, page: "transaction" },
    { to: "/admin/push-notifications", label: "Notifications", icon: <TbHomeSignal />, page: "push" },
    { to: "/admin/chat-support", label: "Chat Support", icon: <BsChatRightDotsFill />, page: "chat" },
    { to: "/admin/settings", label: "Settings", icon: <IoSettings />, page: "setting" },
    // { to: "/admin/reports", label: "Reports", icon: <LiaUserAstronautSolid />, page: "reports" },
  ];
  return (
    <>
      <div className="dashboard-sidebar">
        <div className="header d-flex align-items-center justify-content-between mb-5">
          <div className="logo d-flex align-items-center justify-content-center w-100">
            {/* <LogoSvg /> */}
            <img src={logo} alt={"logo"} width={40} height={40} />
            {/* <h4 className="ms-3">
              <b className="text-black">Bibo Admin Panel</b>
            </h4> */}
          </div>

          <IoClose
            size={22}
            className="text-black d-block d-md-none"
            onClick={() => closeSidebar("abc")}
          />
        </div>

        <div className="link-wrapper">
          <ul>

            {menuItems.map((item, index) => (
              <li className="mb-3" key={index}>
                <NavLink to={item.to} onClick={() => closeSidebar(item.page)}>
                  <div className="icon-wrapper">{item.icon}</div>
                  {
                    !isCollapsed ?
                      <span className={`${activePage === item.page ? "active-li" : ""}`}>{item.label}</span>
                      : ""
                  }
                </NavLink>
              </li>
            ))}
            <li className="mb-3 li-logout">
              <Button
                type="submit"
                onClick={() => setIsLogoutModalOpen(true)}
                // disabled={isLoading}
                className="btn-solid btn-p mt-4 logout"
              >
                logout <IoMdArrowForward size={25} />

              </Button>
            </li>
          </ul>
        </div>
      </div>

      <LogoutModal
        isOpen={isLogoutModalOpen}
        setIsOpen={setIsLogoutModalOpen}
        size={'sm'}
      />
    </>
  );
};

export default DashboardSidebar;
